// 對應舊版 @solidjs/router 的 <A>：搬頁面時，舊版的 <A href> 一律換成 <AppLink href>。
// 不直接用 react-router 的 Link：Solid 的 <A> 會自動加 active／inactive class 與 aria-current，
// 舊版 index.css 有 `.menu .active` 這類規則依賴它，少了樣式就會跟舊版不同。
// 判定規則照 Solid 原始碼：路徑不分大小寫，目前路徑等於 href 或以「href/」開頭即 active（end 時只認完全相等）；
// 完全相等才加 aria-current="page"。
// props：href、end、className、activeClassName（預設 'active'）、inactiveClassName（預設 'inactive'），其餘透傳給 <a>
import { Link, useLocation } from 'react-router'

// 網址含不合法的 % 編碼（如 /lines/%）時 decodeURI 會拋錯，選單整個崩掉變白頁；解不開就用原字串比對
const safeDecodeURI = (p) => {
  try {
    return decodeURI(p)
  } catch {
    return p
  }
}

const normalize = (p) => (p.length > 1 ? p.replace(/\/+$/, '') : p).toLowerCase()

export function AppLink({ href, end, className, activeClassName = 'active', inactiveClassName = 'inactive', ...props }) {
  const { pathname } = useLocation()
  const path = normalize(href.split(/[?#]/, 1)[0])
  const loc = normalize(safeDecodeURI(pathname))
  const exact = path === loc
  const active = end ? exact : exact || loc.startsWith(path + '/')
  return (
    <Link
      to={href}
      className={[className, active ? activeClassName : inactiveClassName].filter(Boolean).join(' ')}
      aria-current={exact ? 'page' : undefined}
      {...props}
    />
  )
}
